import React, {Component} from "react";
import styled from "styled-components";
import logo from "../images/c-logo.svg";
import Img from "gatsby-image";
import Link from 'gatsby-link';

const MenuWrapper = styled.header`
  background: ${props => {
  if (props.viewPortWidth <= 800) {
    if (props.toggled) {
      return '#16233e'
    }  else {
      return 'transparent'
    }
  }
  }};
  height: ${props => {
  if (props.viewPortWidth <= 800) {
    if (props.toggled) {
      return '100vh'
    }  else {
      return 'auto'
    }
  }
  }};
  max-height: ${props => {
    if (props.toggled) {
      return '5000px'
    }  else {
      return '0'
    }
  }};
  transition: max-height .3s ease-out;
  width: 100%;
  padding: 1.5em 0;
`;

const Nav = styled.nav`
  ${props => {
  if (props.viewPortWidth <= 800) {
    if (props.toggled) {
      return {
        'display': 'block',
        'position': 'absolute',
        'width': 'auto',
        'top': '50%',
        'transform': 'translateY(-50%)',
        'font-size': '110%',
        
        ul: {
          'display': 'flex',
          'flex-direction': 'column',
        },
        
        '.aboutItem': {
          'transform': 'translateX(1.4em)'
        },

        li: {
          'display': 'flex',
          'flex-direction': 'column',
        },
        
        a: {
          'padding': '1em',
          'font-size': '22px'
        }
        
      };
    }  else {
      return {
        'display': 'none'
      };
    }
  } else {
    return {
      'display': 'block',
      'width': '100%',
      
      li: {
        'display': 'inline-block'
      }
    };
  }
  }};
  margin: 0 auto;
  
  .aboutItem {
    button {
      &:hover {
        cursor: pointer;
      }
    }
  }

  > ul {
    display: flex;
    justify-content: flex-end;
    align-items: ${props => {
      if (props.viewPortWidth <= 800) {
        return 'flex-start'
      } else {
        return 'center'
      }
    }}
  }

  li {
    position: relative;
    
    &:first-child {
      position: relative;
    }
    @media (min-width: ${props => props.theme.responsive.small}) {
      margin-left: 2em;
    }
  }

  a {
    text-decoration: none;
    color: white;
    font-weight: 600;
    font-family: 'Quicksand', sans-serif;
    
    &:hover {
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background: white;
        left: 0;
        top: 28px;
      }
    }
  }
`;

const AboutNav = styled.ul`
  a {
    padding: ${props => {
      if (props.viewPortWidth <= 800) {
        return '0.5em 1em'
      } else {
        return '1em'
      }
    }}
    
    font-size: ${props => {
      if (props.viewPortWidth <= 800) {
        return '18px'
      } else {
        return 'inherit'
      }
    }}
  }
  
  li {
    margin-top: ${props => {
      if (props.viewPortWidth <= 800) {
        return '10px'
      } else {
        return '0'
      }
    }}
  }

  ${props => {
    if (props.toggled) {
      if (props.viewPortWidth <= 800) {
        return {
          'display': 'block',
          'position': 'absolute',
          'width': 'auto',
          'top': '2.5em',
          'left': '0',
          'padding': '.75em 0',
          'transform': 'translateX(1em)',

          li: {
            'display': 'flex',
            'margin-left': '0!important',
            'flex-direction': 'column',
          },

          a: {
            'padding': '0.5em 1em!important',
            'font-size': 'normal',
            'color': '#16233e!important'
          }

        }
      } else {
        return {
          display: 'block',
          position: 'absolute',
          width: 'auto',
          minWidth: '200px',
          top: '2.5em',
          left: '0',
          padding: '.75em 0',
          backgroundColor: 'white',
          transform: 'translatex(-2em)',

          li: {
            'display': 'flex',
            'margin-left': '0!important',
            'flex-direction': 'column',
          },

          a: {
            'padding': '.75em 1em',
            'color': '#16233e!important'
          }

        }
      }
    } else {
      return {
        'display': 'none'
      }
    }
}}
  // max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;

  ul {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  li {
    &:first-child {
      position: relative;
    }
    
    &.active {
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background: white;
        left: 0;
        bottom: 0;
      }
      
       @media (min-width: 800px) {
        a {
          background: ${props => props.theme.colors.grey};
        }
        
        &::after {
          content: none;
        }
      }
    }
    
    @media (min-width: ${props => props.theme.responsive.small}) {
      margin-left: 2em;
    }
  }

  a {
    text-decoration: none;
    color: white;
    font-weight: 600;
    font-family: 'Quicksand', sans-serif;
    
    &:hover {
      background: ${props => props.theme.colors.grey};
      
      &::after {
        content: none;
      }
    }
  }
`;

const MenuButton = styled.button`
  display: ${props => {
  if (props.viewPortWidth <= 800) {
      return 'flex'
  } else {
    return 'none'
  }
  }}
  align-items: center;
  color: white;
  font-weight: 600;
  font-family: 'Quicksand', sans-serif;
  font-size: 100%;
  background: transparent;
  border: none;

`;

const Wrapper = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 864px;
  width: 100%;
  padding: 0 1.5em;
  justify-content: space-between;
  align-items: center;
  
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: 0 2em;
    
    img {
      max-width: 80%;
    }
  }
  
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    max-width: 1200px;
    
    img {
      max-width: 100%;
    }
  }
`;

const AboutButton = styled.button`
  display: flex;
  align-items: center;
  color: white;
  font-weight: 600;
  font-family: 'Quicksand', sans-serif;
  font-size: ${props => {
    if (props.viewPortWidth <= 800) {
      return '22px'
    } else {
      return 'inherit'
    }
  }};
  padding: 0;
  background: transparent;
  border: none;
  
  ${props => {
  if (props.viewPortWidth <= 800) {
    return {
      'pointer-events': 'none',
      
      span: {
        'display': 'none'
      }
    }
  }  else {
    return {

    }
  }
}};
`;

const ArrowDown = styled.span`
  margin-top: ${props => props.toggled ? '8px' : '-2px'};
  margin-left: .5em;
  border: solid white;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transition: transform .2s;
  transform: ${props => props.toggled ? 'rotate(225deg)' : 'rotate(45deg)'};
`;

const LoginIcon = {
  maxWidth: 16,
  width: 16,
  marginLeft: '.5em'
};

const LoginLink = {
  display: 'flex',
  alignItems: 'center'
};

const Logo = styled.a`
  img {
    max-width: 80%;
  }
  
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    img {
      max-width: 100%;
    }
  }
`;

const Title = styled.h2`
  
`;

const IconWrapper = styled.div``;

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: false,
      aboutToggled: false,
      viewPortWidth: null,
      href: null
    };
  }

  setWindowWidth = () => {
     window.requestAnimationFrame(() => {
       this.setState({
         viewPortWidth: window.innerWidth
       })
     })
  };

  componentDidMount() {
    this.setState({
      viewPortWidth: window.innerWidth,
      rootPath: window.location.origin,
      href: window.location.href
    });
    window.addEventListener('resize', this.setWindowWidth);
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setWindowWidth)
  }

  toggleMenu = () => {
    this.setState({
      toggled: !this.state.toggled
    })
  };

  toggleAboutMenu = () => {
    this.setState({
      aboutToggled: !this.state.aboutToggled
    });
  };

  render() {
    return (
      <MenuWrapper viewPortWidth={this.state.viewPortWidth} toggled={this.state.toggled}>
        <Wrapper>
          <Logo href="/">
            <img src={logo} alt="Huvaros" />
          </Logo>
          <MenuButton viewPortWidth={this.state.viewPortWidth} toggled={this.state.toggled} onClick={this.toggleMenu}>Menu <ArrowDown toggled={this.state.toggled}/></MenuButton>
          <Nav viewPortWidth={this.state.viewPortWidth} toggled={this.state.toggled}>
            <Title className="sr-only">Navigation</Title>
            <ul>
              <li>
                <a href="/" className={this.props.homeActive && "activeLinkStyle"}>{this.props.home}</a>
              </li>
              <li className="aboutItem">
                <AboutButton className={this.props.aboutActive && "activeLinkStyle"} viewPortWidth={this.state.viewPortWidth} toggled={this.state.aboutToggled} onClick={this.toggleAboutMenu}>{this.props.features} <ArrowDown toggled={this.state.aboutToggled}/></AboutButton>
                <AboutNav viewPortWidth={this.state.viewPortWidth} toggled={this.state.aboutToggled}>
                  {this.props.aboutDetailLinks.map((link, index) => (
                    <li className={(() => this.state.href && this.state.href.indexOf(link.slug) > -1 ? "active" : "")()} key={index}>
                      <a href={this.state.rootPath + "/" + link.slug}>{link.title}</a>
                    </li>
                  ))}
                </AboutNav>
              </li>
              <li>
                <Link to="/about" exact activeClassName={'activeLinkStyle'}>{this.props.about}</Link>
              </li>
              <li>
                <Link to="/contact" exact activeClassName={'activeLinkStyle'}>{this.props.contact}</Link>
              </li>
              <li>
                <a style={LoginLink} href={this.props.loginLink} target="_blank">
                  {this.props.login}

                  {this.props.loginIcon &&
                    <IconWrapper>
                      <Img style={LoginIcon} sizes={this.props.loginIcon.sizes} alt="external link"/>
                    </IconWrapper>
                  }

                </a>
              </li>
            </ul>
          </Nav>
        </Wrapper>
      </MenuWrapper>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js